import React from 'react'

import AnimatedCircle from 'components/AnimatedCircle'
import HowToDialog from 'components/HowToDialog'
import T from 'components/FormattedMessage'

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'

import koinsIconUrl from './assets/icon_koins.svg'
import KoinCounter from '../KoinCounter'

interface Props {
  open: boolean
  delay: number
  duration: number
  onClose?: () => void
}

const styles = createStyles({
  headlineContainer: {
    height: 70,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headlineKoins: {
    fontSize: '170%',
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const KoinIntro: React.SFC<InjectedProps> = ({ classes, onClose, delay, duration, ...props }) => {
  const [shouldDisplayCoins, toggleDisplayCoins] = React.useState(false)
  const [shouldDisableAction, toggleActionDisable] = React.useState(true)

  React.useEffect(() => {
    window.setTimeout(() => toggleDisplayCoins(true), delay)
  }, [delay])

  const headline = shouldDisplayCoins
    ? <span className={classes.headlineKoins}><KoinCounter from={0} to={1000} duration={duration} /></span>
    : <T id="koin_intro_title" />

  return (
    <HowToDialog
      variant="light"
      displayFAQ
      headline={<div className={classes.headlineContainer}>{headline}</div>}
      message={<T id="koin_intro_message" />}
      actionLabel={<T id="koin_intro_dismiss" />}
      onActionClick={onClose}
      disableAction={shouldDisableAction}
      icon={(
        <AnimatedCircle
          iconUrl={koinsIconUrl}
          delay={delay}
          duration={duration}
          onCircleAnimationEnd={() => toggleActionDisable(false)}
        />
      )}
      {...props}
    />
  )
}

export default withStyles(styles)(KoinIntro)
